<script lang="ts">
	import { base } from '$app/paths';
	import { assetsUrl } from './shared/assets';

	export let user: User;
</script>

<li class="py-6 flex flex-col">
	<div class="flex items-stretch pb-6 space-x-6 overflow-hidden">
		{#if user.statistics.objects.length}
			{@const object = user.statistics.objects[0]}
			<a href="{base}/object/{object.id}" class="space-x-2 flex">
				{#each object.images as image}
					<picture>
						<img
							src="{assetsUrl}{image.preview.webp}"
							width={image.preview.width}
							height={image.preview.height}
							class="h-20 w-auto"
							alt=""
						/>
					</picture>
				{/each}
			</a>
		{/if}
		<a
			class="flex items-center bg-white text-lg-fluid no-underline"
			href="{base}/user/?id={user.id}">{user.name}</a
		>
	</div>
	<div class="flex whitespace-nowrap">
		<div class="flex flex-col md:flex-row">
			<span>Transkriptionen: {user.statistics.submissions}</span>
			<span class="md:ml-10">Bestätigungen: {user.statistics.approvals}</span>
		</div>
		<div class="ml-auto">
			<a href="{base}/user/?id={user.id}" class="inline-flex items-center space-x-2 link-icon"
				><span>Profil anzeigen</span><svg
					width="18.707"
					height="14.707"
					aria-hidden="true"
					focusable="false"><use xlink:href="#icon-arrow" /></svg
				></a
			>
		</div>
	</div>
</li>
